import React from "react";
import styles from './AccountItem.module.sass';
import Grid from '@mui/material/Grid';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import cn from 'classnames';
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";

const AccountItem = ( { title, onClick, icon, path } ) => {

    const getContent = () => {
        return <Grid
            container
            spacing={2}
            className={cn(styles.accordion_item)}>
            
            <Grid item xs={1} style={{ textAlign: 'right' }}>
                {icon}
            </Grid>
            <Grid item xs={10}>
                {title}
            </Grid>
            <Grid item xs={1}>
                <KeyboardArrowRightIcon />
            </Grid>
        </Grid>
    };

    return (
        <>
            { path && <Link to={path} className='link'>{getContent()}</Link> }
            { onClick && <div onClick={onClick} className='link'>{getContent()}</div> }
        </>
    );

};

export default AccountItem;